export default {
  contentCenterTips: 'A display with the finest #ShotonOPPO entries and Merchandise to inspire!'
}